import React from 'react';
import { Form, Input, Button as AntButton } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
// Styles
import styles from './TalentQuestions.module.scss';

type TalentQuestionsProps = {
  name: string;
  placeholder?: string;
  editable?: boolean;
  maxQuestions?: number;
};

const DEFAULT_MAX = 5;

export const TalentQuestions: React.FC<TalentQuestionsProps> = ({
  name,
  placeholder,
  editable = true,
  maxQuestions = DEFAULT_MAX,
}) => (
  <Form.List name={name}>
    {(fields, { add, remove }) => (
      <div className={styles.root}>
        {fields.length === 0 && (
          <>
            <h4 className={styles.title}>Talent Questions</h4>
            <p className={styles.description}>
              Add up to {maxQuestions} required custom questions for applicants
              to answer to help qualify talent.
            </p>
          </>
        )}

        {fields.map((field, index) => (
          <div className={styles.inputWrapper} key={field.key}>
            <Form.Item
              {...field}
              label={`Question ${index + 1}`}
              rules={[{ message: 'Please enter a question' }]}
              className={styles.formItem}
            >
              <Input
                disabled={!editable}
                placeholder={placeholder}
                autoComplete="off"
                width={500}
              />
            </Form.Item>
            <MinusCircleOutlined
              className={styles.icon}
              onClick={() => remove(field.name)}
            />
          </div>
        ))}

        <div className={styles.addMoreWrapper}>
          <AntButton
            type="dashed"
            onClick={() => add('')}
            disabled={!editable || fields.length >= maxQuestions}
            icon={<PlusOutlined />}
            className={styles.addMoreButton}
          >
            Add Question
          </AntButton>
        </div>
      </div>
    )}
  </Form.List>
);

export default TalentQuestions;
